import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useUser();
  if (user === undefined) return null; // Or a loader
  return user ? children : <Navigate to="/auth" replace />;
};

export default ProtectedRoute;
